import * as React from "react";
import { Outlet } from "react-router-dom";
import AdminHeader from "../components/Admin/AdminLayout/AdminHeader";
import AdminSidebar from "../components/Admin/AdminLayout/AdminSidebar";
import Drawer from "@mui/material/Drawer";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";

const drawerWidth = 240;

const AdminPage = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      const isTime = checkTokenExpiration(accessToken);
      if (isTime) {
      } else {
        navigate("/admin/login");
      }
    } else {
      navigate(`/admin/login`);
    }
  }, []);

  const checkTokenExpiration = (token) => {
    try {
      const decoded = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);
      if (decoded.exp < currentTime) {
        toast("Hết thời gian làm việc, vui lòng đăng nhập lại", {
          type: "error",
          autoClose: 2000,
        });
        localStorage.removeItem("accessToken");
        localStorage.removeItem("userId");
        return false;
      }
      return true;
    } catch (error) {
      console.error("Token không hợp lệ hoặc bị lỗi:", error);
      return false;
    }
  };

  return (
    <Grid
      container
      sx={{
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <Grid
        sx={{
          width: `${drawerWidth}px`,
          height: "100vh",
        }}
      >
        <Drawer
          open={true}
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              height: "100vh",
            },
          }}
        >
          <AdminSidebar />
        </Drawer>
      </Grid>
      <Grid
        sx={{
          flex: 1,
          height: "100vh",
          overflowY: "auto",
        }}
      >
        <AdminHeader />
        <Outlet />
      </Grid>
    </Grid>
  );
};

export default AdminPage;
